export const UPDATE_USERDETAILS = "UPDATE_USERDETAILS";
export const UPDATE_TOTAL_COIN = "UPDATE_TOTAL_COIN";
export const LOGOUT = "LOGOUT";
export const USERLOGIN = "USERLOGIN";